import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { PatchBlockedSlotBody } from '@snootsvet/shared'

import { useOsApi } from '@/frontend/hooks/api/use-os-api'

/** Updates a blocked slot and invalidates the blocked-slots query cache. */
export function useUpdateBlockedSlot() {
  const api = useOsApi()
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ id, ...body }: PatchBlockedSlotBody & { id: string }) => {
      const response = await api.patch('/blocked-slots/:id', { params: { id }, body })
      if (!response.success) {
        throw new Error(response.error.message)
      }
      return response.data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['blocked-slots'] })
    },
  })
}
